import { render, staticRenderFns } from "./AscCustomAlertsNoData.vue?vue&type=template&id=b14f8c5e&"
import script from "./AscCustomAlertsNoData.vue?vue&type=script&lang=js&"
export * from "./AscCustomAlertsNoData.vue?vue&type=script&lang=js&"
import style0 from "./AscCustomAlertsNoData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports